/**
 * Canonical web URL for sharing/copying a verse (not Telegram deep link).
 * Set VITE_BIBLE_PUBLIC_ORIGIN in env (no trailing slash), e.g. https://www.biblefirst.co
 */
export function getBiblePublicOrigin() {
  const raw = import.meta.env.VITE_BIBLE_PUBLIC_ORIGIN;
  if (typeof raw === 'string' && raw.trim()) return raw.replace(/\/+$/, '');
  return 'https://www.biblefirst.co';
}

export function buildPublicVerseUrl(translation, bookId, chapter, verse) {
  const t = String(translation || 'kjv').replace(/^\/+|\/+$/g, '') || 'kjv';
  const b = String(bookId ?? '').replace(/^\/+|\/+$/g, '');
  const c = String(chapter ?? '').replace(/^\/+|\/+$/g, '');
  const v = String(verse ?? '').replace(/^\/+|\/+$/g, '');
  return `${getBiblePublicOrigin()}/${t}/${b}/${c}/${v}`;
}
